import React from 'react';
import { Helmet } from 'react-helmet';

const DigitalRightsPage = () => (
  <>
    <Helmet>
      <title>الحقوق الرقمية | منظمة جاستيس للحقوق والتنمية</title>
    </Helmet>
    <div className="section">
      <h1 className="section-title">الحقوق الرقمية</h1>
      <div style={{ maxWidth: 800, margin: '0 auto', textAlign: 'right' }}>
        <p>مقدمة عن الحقوق الرقمية...</p>
      </div>
    </div>
  </>
);

export default DigitalRightsPage; 